import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Info Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M128 2.56c-96.564 0-156.916 104.533-108.634 188.16s168.986 83.627 217.268 0A125.44 125.44 0 0 0 253.44 128C253.367 58.752 197.248 2.633 128 2.56m0 231.582c-81.708.003-132.774-88.446-91.924-159.209C76.927 4.171 179.062 4.166 219.92 74.925A106.14 106.14 0 0 1 234.14 128c-.066 58.593-47.548 106.075-106.141 106.142m19.299-48.247c0 5.33-4.32 9.65-9.65 9.65-10.658 0-19.298-8.64-19.298-19.299V128c-7.428 0-12.07-8.041-8.357-14.474a9.65 9.65 0 0 1 8.357-4.824c10.658 0 19.298 8.64 19.298 19.298v48.246c5.33 0 9.65 4.32 9.65 9.65M108.7 74.93c0-11.142 12.062-18.106 21.711-12.535 9.65 5.571 9.65 19.499 0 25.07a14.5 14.5 0 0 1-7.237 1.94c-7.994 0-14.474-6.48-14.474-14.475" }, null, -1)
  ])))
}
export default { render: render }